<template>
    <div>
        <def-autocomplete
            :options="optionsCity"
            :result="this.cities"
            v-model="optionsCity.open"
            @change="handlerChangeCity"
        >
            <input
                type="text"
                style="visibility: hidden; position: absolute"
                :name="`ORDER_PROP_${result.postCity.ID}`"
                :value="selectedCity.UF_XML_ID && selectedCity.UF_NAME"
                :required="result.postCity.REQUIRED === 'Y'"
                @invalid="({ target }) => target.classList.add('invalid-post')"
            >
            <input
                :value="selectedCity.UF_NAME"
                @input="handlerInputCity"
                @click="handlerCityClick"
                style="width: 100%"
                :placeholder="result.postCity.NAME"
                invalidText=" "
                autocomplete="disable"
                class="def-input"



            />
        </def-autocomplete>

        <def-autocomplete
            :options="optionStreet"
            :result="streets"
            v-model="optionStreet.open"
            @change="handlerChangeStreet"
        >
            <input
                type="text"
                style="visibility: hidden; position: absolute"
                :name="`ORDER_PROP_${result.postOffice.ID}`"
                :value="selectedStreet.UF_XML_ID && selectedStreet.UF_NAME"
                :required="result.postOffice.REQUIRED === 'Y'"

                @invalid="({ target }) => target.classList.add('invalid-post')"
            >

            <input
                :value="selectedStreet.UF_NAME"
                @input="handlerInputWarehouse"
                @click="handlerStreetClick()"
                style="width: 100%"
                invalidText=" "
                :placeholder="result.postOffice.NAME"
                autocomplete="disable"
                class="def-input"
            />
        </def-autocomplete>

    </div>
</template>

<script>
    export default {
        name: 'new-post-office',
        props: ['result'],
        data() {
            return {
                timeOut: {
                    city: null,
                    street: null
                },
                optionsCity: {
                    text: 'UF_NAME',
                    value: 'UF_XML_ID',
                    open: false
                },
                selectedCity: {
                    UF_NAME: '',
                    UF_XML_ID: '',
                },
                cities: [],
                optionStreet: {
                    text: 'UF_NAME',
                    value: 'UF_XML_ID',
                    open: false
                },
                selectedStreet: {
                    UF_NAME: '',
                    UF_XML_ID: '',
                },
                streets: [],
            }
        },
        methods: {
            // city
            handlerInputCity({ target: { value } }) {
                this.$set(this.selectedCity, 'UF_NAME', value);
                this.getCity(true);
                this.optionsCity.open = true;
            },
            getCity(clear) {
                if (clear) {
                    this.selectedCity.UF_XML_ID = '';
                }

                clearTimeout(this.timeOut.city);

                return new Promise ((resolve, reject) => {
                    try {
                        const request = async () => {
                            const {action, LANGUAGE_ID, path} = this.result?.deliveryRouts?.routes?.getCities;
                            const response = await axios.get(path, {
                                params: {
                                    action,
                                    LANGUAGE_ID,
                                    city: this.selectedCity.UF_NAME,
                                }
                            })
                            const { cities } = response?.data;
                            if (
                                response.status === 200 &&
                                cities &&
                                Array.isArray(cities) &&
                                cities.length > 0
                            ) {
                                this.cities = cities;
                                this.streets = [];
                                this.selectedStreet = {
                                    UF_NAME: '',
                                    UF_XML_ID: '',
                                }
                            }
                            this.$emit('change');
                            resolve();
                        }
                        this.timeOut.city = setTimeout(request, 300);
                        // request();
                    } catch (err) {
                        console.error(err);
                        reject();
                    }
                })
            },
            async handlerChangeCity(city) {
                this.selectedCity = city;
                await this.getCity();
                // this.optionsCity.open = false;
            },
            handlerCityClick() {
                this.getCity();
                this.optionsCity.open = !this.optionsCity.open;
            },
            // street
            handlerInputWarehouse({ target: { value } }) {
                this.$set(this.selectedStreet, 'UF_NAME', value);
                this.getStreet(true);
            },
            getStreet(clear) {
                if (clear) {
                    this.selectedStreet.UF_XML_ID = '';
                }
                clearTimeout(this.timeOut.street);
                if (this.selectedCity?.UF_XML_ID) {
                    return new Promise( (resolve, reject) => {
                        try {
                            const request = async () => {
                                const {action, path, LANGUAGE_ID} = this.result?.deliveryRouts?.routes?.getWarehouses;
                                const response = await axios.get(path, {
                                    params: {
                                        action,
                                        LANGUAGE_ID,
                                        city: this.selectedCity?.UF_XML_ID,
                                        warehouse: this.selectedStreet?.UF_NAME,
                                    }
                                })
                                if (
                                    response.status === 200 &&
                                    response.data.warehouses &&
                                    Array.isArray(response.data.warehouses) &&
                                    response.data.warehouses.length > 0
                                ) {
                                    this.streets = response.data.warehouses;
                                }
                                this.$emit('change');
                                resolve();
                            }
                            this.timeOut.street = setTimeout(request, 300);
                        } catch (err) {
                            console.error(err);
                            reject();
                        }
                    });
                }
            },
            async handlerChangeStreet(street) {
                this.selectedStreet = street;
                await this.getStreet();
            },
            handlerStreetClick() {
                this.getStreet();
                this.optionStreet.open = !this.optionStreet.open;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .invalid-post:invalid {
        & + .def-input{
            border-color: #C80024 !important;
        }
    }
    .def-input{
        width: 100%;
        padding: 0 16px;
        height: 48px;
        font-size: rem(16);
        border: 1px solid #DFDFDF;
        font-weight: 500;
        color: #757575;
        &::placeholder{
            color: #757575;
        }
    }
</style>